export default "__VITE_ASSET__iIiNvsdk__"